import './components/app.js';
import { installInputFeedback } from './core/input-feedback.js';

installInputFeedback(document);
